import { CaretDown, Check } from "@phosphor-icons/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { useLang } from "../context/LanguageContext";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, langs } = useLang();
  const current = langs.find((l) => l.code === lang) || langs[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className="group inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-3 py-2 text-[14px] font-semibold text-slate-700 shadow-sm transition-colors hover:border-slate-400 hover:text-slate-900 lg:text-base"
      >
        <span className="text-lg leading-none" aria-hidden>
          {current.flag}
        </span>
        <span className="font-mono tracking-widest">{current.label}</span>
        {!compact && (
          <CaretDown
            size={14}
            weight="bold"
            className="transition-transform group-data-[state=open]:rotate-180"
          />
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-[180px] border-slate-200 bg-white text-slate-900"
      >
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onSelect={() => setLang(l.code)}
            className="flex cursor-pointer items-center justify-between gap-4 text-slate-700 focus:bg-slate-100 focus:text-slate-900"
          >
            <span className="flex items-center gap-3">
              <span className="text-lg leading-none" aria-hidden>
                {l.flag}
              </span>
              <span className="font-mono text-[11px] tracking-widest text-blue-600">
                {l.label}
              </span>
              <span className="text-sm">{l.name}</span>
            </span>
            {lang === l.code && (
              <Check size={14} weight="bold" className="text-blue-600" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
